import { render, staticRenderFns } from "./SubContentContainer.vue?vue&type=template&id=476b3762&"
import script from "./SubContentContainer.vue?vue&type=script&lang=js&"
export * from "./SubContentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports